import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { HomeControllerModule } from './controllers/HomeController';

export const HomeView = angular
  .module('acme.view.home', [uiRouter, 'ui.bootstrap', HomeControllerModule])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'home',
      url: '/register',
      abstract: true,
      views: {
        main: {
          controller: 'HomeController',
          templateUrl: 'layouts/standard.tpl.html',
        },
      },
      data: {
        pageClass: 'application-splash',
      },
    });

    $stateProvider.state({
      name: 'home.default',
      url: '',
      views: {
        'subview-main': {
          templateUrl: 'views/home/home.tpl.html',
        },
      },
      data: {
        pageTitle: 'Welcome',
      },
    });
  }).name;
